module.exports = __webpack_public_path__ + "static/img/mb-04.7bf6003.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h2/mb-04.jpg
// module id = J3re
// module chunks = 1